import { render } from "./UpcomingFixture.vue?vue&type=template&id=6c71632a&scoped=true"
import script from "./UpcomingFixture.vue?vue&type=script&lang=js"
export * from "./UpcomingFixture.vue?vue&type=script&lang=js"

import "./UpcomingFixture.vue?vue&type=style&index=0&id=6c71632a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c71632a"]])

export default __exports__